import { Card, MultiSelect, Skeleton, SpinnerIcon } from 'corso-admin-ui';

const toOptions = (tags: { name: string }[]) =>
  tags.map(({ name }) => ({ label: name, value: name }));

function TagsCardSkeleton() {
  return (
    <Card>
      <Card.Heading>Tags</Card.Heading>
      <Skeleton.Rectangle height="4rem" width="100%" />
    </Card>
  );
}

/** Tag editor for a single entity — the store's tags as options, creatable, saved on change. */
export function TagsCard({
  storeTags,
  currentTags,
  isLoading,
  isSaving,
  onChange,
}: {
  storeTags: { name: string }[];
  currentTags: { name: string }[];
  isLoading: boolean;
  isSaving: boolean;
  onChange: (tagNames: string[]) => void;
}) {
  return (
    <Skeleton isLoading={isLoading} skeleton={TagsCardSkeleton}>
      <Card>
        <MultiSelect
          label={
            <div className="flex items-center gap-2">
              <Card.Heading>Tags</Card.Heading>
              {isSaving && <SpinnerIcon className="h-3 w-3" />}
            </div>
          }
          placeholder="Add tags"
          options={toOptions(storeTags)}
          value={toOptions(currentTags)}
          onChange={(changedTags) =>
            onChange(changedTags.map((tag) => tag.value))
          }
          creatable
        />
      </Card>
    </Skeleton>
  );
}
